import { render, staticRenderFns } from "./ServiceProcessing.vue?vue&type=template&id=2f13215e&scoped=true&"
import script from "./ServiceProcessing.vue?vue&type=script&lang=js&"
export * from "./ServiceProcessing.vue?vue&type=script&lang=js&"
import style0 from "./ServiceProcessing.vue?vue&type=style&index=0&id=2f13215e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f13215e",
  null
  
)

export default component.exports